module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-swap-green-c7d782.svg";